import feeType from '@/api/fee-type'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  edit_data: {}
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA(state, data) {
    state.edit_data = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attrubutes
    )
    return feeType.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  update(context, data) {
    return feeType.update(data)
  },

  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await feeType.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  }
}
